import {
  Email,
  Facebook,
  Instagram,
  Phone,
  Twitter,
  YouTube,
} from "@mui/icons-material";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { ISetting } from "../interfaces/ISetting";
type iFooter = {
  setting: ISetting | undefined;
};
const Footer: React.FC<iFooter> = ({ setting }) => {
  const theme = useTheme();
  return (
    <Box>
      <Grid
        container
        direction="row"
        sx={{ backgroundColor: theme.palette.primary.main, p: 2 }}
      >
        <Grid item md={4} xs={12} p={2.5}>
          <Box className="mt-4  text-gray-300">
            Do not post duplicate ad Please! Otherwise all stories will be
            deleted and your account will be banned. Please co-operate with us
            as a good poster!
          </Box>
        </Grid>
        <Grid item md={4} xs={12} p={2.5}>
          <Typography variant="h5" sx={{ color: "#fff" }}>
            Quick Link
          </Typography>
          <Box className="mt-4">
            <a
              href="/about"
              className="hover:underline text-gray-300 block mb-2"
            >
              About Us
            </a>
            <a
              href="/privacy-policy"
              className="hover:underline text-gray-300 block mb-2"
            >
              Privacy Policy
            </a>
            <a
              href="/term-conditions"
              className="hover:underline text-gray-300 block mb-2"
            >
              Terms & Conditions
            </a>
            <Link
              to="/contact-us"
              className="hover:underline text-gray-300 block"
            >
              Contact Us
            </Link>
          </Box>
        </Grid>
        <Grid item md={4} xs={12} p={2.5}>
          <Typography variant="h5" sx={{ color: "#fff" }}>
            Contact Us
          </Typography>
          <Box className="mt-4">
            <Box className="text-gray-300">
              <Phone className="pr-2" />
              {setting?.phone1}
              {setting?.phone2 ? `, ${setting.phone2}` : ""}
            </Box>
            <Box className="text-gray-300">
              <Email className="pr-2" /> {setting?.primary_email}
              {setting?.alternate_email ? `, ${setting.alternate_email}` : ""}
            </Box>
            <Box className="text-gray-300">
              <Typography variant="h6" sx={{ color: "#fff" }}>
                Follow Us
              </Typography>
            </Box>
            <Box className="text-gray-300">
              <a href={setting?.facebook_link ?? "#"}>
                <Facebook className="pr-2" fontSize="large" />
              </a>
              <a href={setting?.instagram_link ?? "#"}>
                <Instagram className="pr-2" fontSize="large" />
              </a>
              <a href={setting?.youtube_link ?? "#"}>
                <YouTube className="pr-2" fontSize="large" />
              </a>
              <a href={setting?.twitter_link ?? "#"}>
                <Twitter className="pr-2" fontSize="large" />
              </a>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box
        sx={{
          backgroundColor: theme.palette.primary.light,
          p: 2,
        }}
      >
        <Typography variant="body1" align="center" className="text-gray-200">
          © Copyright 2023 Bookmarking
        </Typography>
      </Box>
      <div
            dangerouslySetInnerHTML={{
              __html: setting?.footer_script as string,
            }}
          />
    </Box>
  );
};
export default Footer;
